import React from "react";

const UploadIcon = () => {
  return (
    <div>
      <svg
        fill="currentColor"
        width="24px"
        height="24px"
        viewBox="0 0 256 256"
        id="Flat"
        xmlns="http://www.w3.org/2000/svg"
        stroke="currentColor"
        stroke-width="5.12"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <path d="M83.17139,84.81738a4.00016,4.00016,0,0,1,.00049-5.65722l42-41.98926a4.00206,4.00206,0,0,1,5.65624,0l42,41.98926a4.00026,4.00026,0,0,1-5.65624,5.6582L132,49.65527V152a4,4,0,0,1-8,0V49.65527L88.82812,84.81836A4,4,0,0,1,83.17139,84.81738ZM216,148a4.0002,4.0002,0,0,0-4,4v56a4.00427,4.00427,0,0,1-4,4H48a4.00427,4.00427,0,0,1-4-4V152a4,4,0,0,0-8,0v56a12.01343,12.01343,0,0,0,12,12H208a12.01343,12.01343,0,0,0,12-12V152A4.0002,4.0002,0,0,0,216,148Z"></path>{" "}
        </g>
      </svg>
    </div>
  );
};

export default UploadIcon;
